import Skeleton from "react-loading-skeleton";
import {
  SKELETON_BASE_COLOR,
  SKELETON_HIGHLIGHT_COLOR,
} from "../../utils/constants";

export const CoopCardLoader = ({ count = 1 }: { count?: number }) => {
  return (
    <div className="flex flex-col gap-2">
      {Array.from({ length: count }).map((_, i) => {
        return (
          <div
            key={`${i}`}
            className="flex items-center gap-4 px-6 py-3 bg-white w-full border rounded-lg border-pry-dark-green-300/10"
          >
            <Skeleton
              width={"48px"}
              height={"48px"}
              baseColor={SKELETON_BASE_COLOR}
              highlightColor={SKELETON_HIGHLIGHT_COLOR}
              className="rounded-full"
            />

            <Skeleton
              width={"100px"}
              height={"24px"}
              baseColor={SKELETON_BASE_COLOR}
              highlightColor={SKELETON_HIGHLIGHT_COLOR}
              className="rounded-"
            />
          </div>
        );
      })}
    </div>
  );
};
